@if (showLoader()) {
    <app-loader [isOverlay]="false" size="small" />
} @else if (cards().length) {
    @for (card of cards(); track card.cardId) {
        @if (isJobsBillingCard(card)) {
            <wk-card-jobs-billing
                [cardData]="card"
                [statusIds]="card.statusIds"
                [format]="'column'"
                [matchedField]="getMatchedFieldForCard(card.cardId)"
                [isFromSearch]="true"
            ></wk-card-jobs-billing>
        } @else if (isT1Card(card)) {
            <wk-card-t1
                [cardData]="card"
                [statusIds]="card.statusIds"
                [format]="'column'"
                [hideArrows]="true"
                [matchedField]="getMatchedFieldForCard(card.cardId)"
            ></wk-card-t1>
        }
    }
} @else {
    <div class="wk-search-result__empty">{{ "SearchBar.EmptySearchResult" | translate }}</div>
}
